import Details from '@/components/Details/Details';
import useFeature from '@/hooks/useFeature';
import IEventType from '@/types/IEventType';
import { Box, Button, ButtonGroup, FormControl, FormLabel, IconButton, Input, Link, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import { FcMoneyTransfer } from 'react-icons/fc';
import { FiShare, FiTrash } from 'react-icons/fi';
import { useSectionPaymentsController } from './section-payments.controller';

export interface ISectionLimitsProps {
	service: IEventType;
	onChange: (values: Partial<IEventType>) => void;
}

export default function SectionPayments(props: ISectionLimitsProps) {
	const { form, handleSubmit, handleRemovePaymentLinkClick } = useSectionPaymentsController(props);

	if (!useFeature('PAYMENTS')) {
		return null;
	}

	return (
		<Details image={<FcMoneyTransfer />} title={t('Payments')}>
			{props.service.tags.tt_payment_url ? (
				<Box
					p={4}
					borderColor="gray.200"
					borderWidth={1}
					borderRadius="md"
					display="grid"
					gap={4}
					gridTemplateColumns="1fr auto"
					overflow="hidden"
					alignItems="center"
				>
					<Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
						<Text>Payment link</Text>
						<Link
							fontSize="sm"
							color="blue.500"
							target="_blank"
							textOverflow="ellipsis"
							whiteSpace="nowrap"
							overflow="hidden"
						>
							{props.service.tags.tt_payment_url}
						</Link>
					</Box>
					<ButtonGroup isAttached variant="outline">
						<IconButton
							icon={<FiShare />}
							aria-label="Edit"
							onClick={() => navigator.clipboard.writeText(props.service.tags.tt_payment_url!)}
						/>
						<IconButton onClick={handleRemovePaymentLinkClick} icon={<FiTrash />} aria-label="Remove" />
					</ButtonGroup>
				</Box>
			) : (
				<Box py={2} as="form" onSubmit={handleSubmit}>
					<FormControl>
						<FormLabel>{t('Product name')}</FormLabel>
						<Input isDisabled={form.formState.isSubmitting} {...form.register('name')} />
					</FormControl>

					<FormControl mt={4}>
						<FormLabel>{t('Price')} (cents)</FormLabel>
						<Input isDisabled={form.formState.isSubmitting} {...form.register('unit_amount')} />
					</FormControl>

					<Button mt={6} size="sm" w="full" colorScheme="primary" type="submit" isLoading={form.formState.isSubmitting}>
						{t('Generate payment link')}
					</Button>
				</Box>
			)}
		</Details>
	);
}
